import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute, UrlSerializer, NavigationExtras } from '@angular/router';

import { AuthenticationService } from '@services/authentication.service';
import { Observable } from 'rxjs';
import { catchError, map, skip, take } from 'rxjs/operators';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { DirectionService } from '@app/_services/direction.service';
import { json } from 'express';

@Injectable({ providedIn: 'root' })
export class LangGuard  {
    constructor(
        private router: Router,
        private translation: TranslateService,
        private direction: DirectionService,
        private route: ActivatedRoute,
        private urlSerializer: UrlSerializer,
        public translate: TranslateService,
        private authService: AuthenticationService
    ) {
        translate.addLangs(['en', 'ar']);

        translate.setDefaultLang('en');

        translate.onLangChange.subscribe((langEvent) => {
            if (langEvent.lang == 'ar') {

                if (direction.value != "rtl")
                    direction.value = "rtl";


            } else if (langEvent.lang == 'en') {
                if (direction.value != "ltr")
                    direction.value = "ltr";
            }
        });
    }
    userLang;

    localizeAndNavigate(commands, navigationExtras, navigate) {
        if (!this.translation.currentLang || this.translation.currentLang != commands[0]) {
            this.translation.use(this.userLang);
        }

        if (commands[0] == 'ar' || commands[0] == '/ar') {
            this.direction.value != "rtl" ? this.direction.value = "rtl" : null;
        } else {
            this.direction.value != "ltr" ? this.direction.value = "ltr" : null;
        }
        if (commands && _.isArray(commands) && commands[commands.length - 1] === '') {
            commands.pop();
        }
        if (navigate) {
            this.router.navigate(commands, navigationExtras);
            return true;
        }
        return null;

    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {


        let stateUrl = state.url.split('/');

        if (stateUrl[0] == "") stateUrl.shift();

        let commands = [];
        let navigationExtras: NavigationExtras;

        const tree = this.router.parseUrl(this.router.url);

        let url: any = this.urlSerializer.parse(state.url);


        stateUrl.forEach((segment) => {
            if (segment == "") return;

            if (segment.includes('?')) {
                commands.push(segment.split('?')[0]);
                if (!_.isEmpty(url.queryParams) || !_.isEmpty(tree.queryParams)) {
                    navigationExtras = {
                        queryParams: url.queryParams ?? tree.queryParams
                    };
                }

            } else {
                commands.push(segment);
            }
        });

        //if url has locale just nake sure direction and translation are set and return
        if (commands[0] == "en" || commands[0] == "ar") {
            this.userLang = commands[0];
            this.localizeAndNavigate(commands, navigationExtras, false);
            return true;
        }

        //if url is not localized use user lang, confirm direction and translation then navigate
        if (!this.userLang) {
            return this.authService.currentUser.pipe(
                skip(1),
                take(1),
                map((user) => {
                    this.userLang = user?.preferences?.language;
                    if (!this.userLang) this.userLang = 'en';
                    commands.unshift(this.userLang);
                    this.localizeAndNavigate(commands, navigationExtras, true);
                    return true;
                },catchError(error=>{

                    this.localizeAndNavigate('en', navigationExtras, true);
                    return error;
                }))
            );
        } else {
            commands.unshift(this.userLang);
            this.localizeAndNavigate(commands, navigationExtras, true);
            return true;
        }




    }
}